module.exports = __webpack_public_path__ + "static/media/icon_lever2.c7c315de.svg";